import { render, staticRenderFns } from "./page-error.vue?vue&type=template&id=60362e6e&"
import script from "./page-error.vue?vue&type=script&lang=js&"
export * from "./page-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports